/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForceUpdateNftOwnershipResponse
 */
export interface ForceUpdateNftOwnershipResponse {
    /**
     * 
     * @type {number}
     * @memberof ForceUpdateNftOwnershipResponse
     */
    refreshed: number;
    /**
     * 
     * @type {number}
     * @memberof ForceUpdateNftOwnershipResponse
     */
    deleted: number;
    /**
     * 
     * @type {number}
     * @memberof ForceUpdateNftOwnershipResponse
     */
    missingMetadata: number;
}

/**
 * Check if a given object implements the ForceUpdateNftOwnershipResponse interface.
 */
export function instanceOfForceUpdateNftOwnershipResponse(value: object): value is ForceUpdateNftOwnershipResponse {
    if (!('refreshed' in value) || value['refreshed'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('missingMetadata' in value) || value['missingMetadata'] === undefined) return false;
    return true;
}

export function ForceUpdateNftOwnershipResponseFromJSON(json: any): ForceUpdateNftOwnershipResponse {
    return ForceUpdateNftOwnershipResponseFromJSONTyped(json, false);
}

export function ForceUpdateNftOwnershipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForceUpdateNftOwnershipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'refreshed': json['refreshed'],
        'deleted': json['deleted'],
        'missingMetadata': json['missingMetadata'],
    };
}

export function ForceUpdateNftOwnershipResponseToJSON(json: any): ForceUpdateNftOwnershipResponse {
    return ForceUpdateNftOwnershipResponseToJSONTyped(json, false);
}

export function ForceUpdateNftOwnershipResponseToJSONTyped(value?: ForceUpdateNftOwnershipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refreshed': value['refreshed'],
        'deleted': value['deleted'],
        'missingMetadata': value['missingMetadata'],
    };
}

